import router from "@/router";
import store from "@/store/index";
import TokenStore from "@/utils/tokenStore";
import Axios from "axios";
import { Message } from "element-ui";

const request = Axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
});

request.interceptors.request.use(
  (config) => {
    if (TokenStore.getToken("operators") !== null) {
      config.headers["Authorization"] = `bearer${TokenStore.getToken(
        "operators"
      )}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

request.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    if (error.response.status === 401) {
      // let regex = /[\u4e00-\u9fa5]/;
      Message({
        message: error.response.data.error_description,
        // message: regex.test(error.response.data.error_description)
        //   ? error.response.data.error_description
        //   : "登录过期，请重新登录~",
        type: "warning",
        duration: 3 * 1000,
      });
      store.dispatch("logout").then(() => {
        router.push({
          name: "登录",
          query: { redirect: window.location.pathname },
        });
      });
    }
    if (error.response.status === 400) {
      Message({
        message:
          error.response.data.error_description === "无法获取用户信息"
            ? "用户名或密码错误"
            : error.response.data.msg,
        type: "error",
        duration: 3 * 1000,
      });
    }
    if (
      error.response.status === 502 ||
      error.response.status === 500 ||
      error.response.status === 404
    ) {
      Message({
        message: "服务器出现错误",
        type: "error",
        duration: 3 * 1000,
      });
    }
    return Promise.reject(error);
  }
);
export default request;
